import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import EscarapelaIcon from '../components/ui/EscarapelaIcon';
import SolDivider from '../components/ui/SolDivider';
import { BADGES_INFO } from '../mockData';
import { motion } from 'framer-motion';

export default function Insignias() {
  const navigate = useNavigate();
  const badgesArray = Object.values(BADGES_INFO);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="max-w-4xl mx-auto space-y-8">
      
      <button onClick={() => navigate(-1)} className="group flex items-center gap-2 text-stone-400 hover:text-[#1B2A4E] transition-colors font-medium">
        <SafeIcon name="ArrowLeft" className="w-4 h-4 group-hover:-translate-x-1 transition-transform" /> Volver
      </button>

      <div className="relative bg-white rounded-[40px] shadow-2xl shadow-stone-200/50 border border-stone-100 overflow-hidden">
        
        {/* Header Band */}
        <div className="bg-[#1B2A4E] p-12 text-white relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#F6B40E] rounded-full blur-[100px] opacity-20 -mr-20 -mt-20"></div>
          <div className="absolute inset-0 opacity-10 sol-watermark" style={{backgroundSize: '400px'}}></div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8 justify-between">
            <div className="max-w-xl">
              <span className="label-technical text-[#F6B40E] mb-2 block">Reconocimientos de la Comunidad</span>
              <h1 className="text-4xl md:text-5xl font-editorial font-bold mb-4">
                Programa de <span className="text-[#74ACDF] italic">Insignias</span>
              </h1>
              <p className="text-white/80 text-lg leading-relaxed">
                Premiamos a los miembros que más aportan al crecimiento de la red. Las insignias se otorgan mensualmente y tienen una validez de 3 meses en tu perfil.
              </p>
            </div>
            
            <div className="w-24 h-24 bg-[#F6B40E] rounded-full flex items-center justify-center text-[#1B2A4E] shadow-xl shrink-0">
              <SafeIcon name="Award" className="w-10 h-10" />
            </div>
          </div>
        </div>

        <div className="p-8 md:p-12 space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {badgesArray.map((badge, idx) => {
              const isAbanderado = badge.id === 'abanderado';
              
              return (
                <motion.div 
                  key={badge.id} 
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  className={`p-6 rounded-[24px] border flex gap-5 transition-all hover:-translate-y-1 hover:shadow-lg ${
                    isAbanderado ? 'bg-[#F6B40E]/5 border-[#F6B40E]/30 shadow-sm' : 'bg-[#FAF9F6] border-stone-100'
                  }`}
                >
                  <div className={`w-14 h-14 rounded-full flex items-center justify-center shrink-0 shadow-sm ${isAbanderado ? 'bg-white border border-stone-200' : 'bg-white text-[#74ACDF] border border-stone-200'}`}>
                    {isAbanderado ? <EscarapelaIcon className="w-8 h-8" /> : <SafeIcon name={badge.icon} className="w-6 h-6" />}
                  </div>
                  <div>
                    <h3 className="font-bold text-xl text-[#1B2A4E] mb-1 font-editorial">{badge.name}</h3>
                    <p className="text-sm text-stone-500 leading-relaxed">{badge.description}</p>
                    
                    {isAbanderado && (
                      <span className="inline-block mt-3 bg-[#1B2A4E] text-[#F6B40E] text-[10px] px-2 py-1 rounded label-technical">
                        Insignia Principal
                      </span>
                    )}
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>

        <SolDivider className="opacity-50" />

        <div className="p-8 md:p-12 text-center bg-stone-50">
          <h3 className="font-editorial font-bold text-2xl text-[#1B2A4E] mb-3">¿Cómo destaco mis insignias?</h3>
          <p className="text-stone-500 max-w-xl mx-auto">
            Podés elegir hasta 3 insignias para mostrar junto a tu nombre en el directorio. La insignia de <strong>Abanderado</strong> siempre se muestra de forma prioritaria si la poseés. Modificá tus preferencias desde "Mi Perfil".
          </p>
        </div>

      </div>
    </motion.div>
  );
}